var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLicenses = function SvgLicenses(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_35_2803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V0Z",
    fill: "#115547"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.586 12L22.257 20.329C20.5479 19.8236 18.7192 19.9023 17.0598 20.5524C15.4003 21.2026 14.0049 22.3872 13.094 23.9191C12.1832 25.451 11.8088 27.2428 12.03 29.0112C12.2513 30.7796 13.0556 32.4239 14.3159 33.6842C15.5761 34.9444 17.2204 35.7487 18.9888 35.97C20.7573 36.1912 22.549 35.8168 24.0809 34.906C25.6128 33.9951 26.7974 32.5997 27.4476 30.9403C28.0978 29.2809 28.1764 27.4521 27.671 25.743L30 23.414V20H33.414L36 17.414V12H30.586ZM20 31C19.4067 31 18.8267 30.8241 18.3333 30.4944C17.84 30.1648 17.4554 29.6962 17.2284 29.1481C17.0013 28.5999 16.9419 27.9967 17.0577 27.4147C17.1734 26.8328 17.4591 26.2982 17.8787 25.8787C18.2983 25.4591 18.8328 25.1734 19.4147 25.0576C19.9967 24.9419 20.5999 25.0013 21.1481 25.2284C21.6962 25.4554 22.1648 25.8399 22.4944 26.3333C22.8241 26.8266 23 27.4067 23 28C23 28.7956 22.6839 29.5587 22.1213 30.1213C21.5587 30.6839 20.7957 31 20 31Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_35_2803",
    x: 0,
    y: 0,
    width: 48,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_35_2803"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLicenses);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "licenses.cbdcece9eac39f535f50a2959d8cce6a.svg";